import React, { ReactNode, useState } from "react";

interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  position?: "top" | "bottom" | "left" | "right";
}

const Tooltip = ({ content, children, position = "top" }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  const tooltipClasses = `absolute z-10 bg-white p-3 rounded-md shadow-md m-2 ${
    position === "top"
      ? "bottom-full left-1/2 transform -translate-x-1/2"
      : position === "bottom"
      ? "top-full left-1/2 transform -translate-x-1/2"
      : position === "left"
      ? "right-full top-1/2 transform -translate-y-1/2"
      : "left-full top-1/2 transform -translate-y-1/2"
  }`;

  return (
    <div className="relative flex items-center">
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="inline-block cursor-pointer"
      >
        <div className="">{children}</div>
      </div>
      {isVisible && <div className={tooltipClasses}>{content}</div>}
    </div>
  );
};

export default Tooltip;
